import React, { useState } from 'react';
import { CameraIcon, RadioIcon, SearchIcon, ListIcon, WifiOffIcon, RefreshCwIcon, CheckCircleIcon, XCircleIcon, ShieldAlertIcon, PlusIcon, MapPinIcon, FileTextIcon, AlertTriangleIcon, UserIcon, ShipIcon, CalendarIcon, NavigationIcon } from 'lucide-react';
import { StatusBadge } from '../components/StatusBadge';
export function MobileFieldOfficer() {
  const [view, setView] = useState<'home' | 'scan' | 'result' | 'compliance' | 'report-case'>('home');
  const [isOnline, setIsOnline] = useState(true);
  const [scanResult, setScanResult] = useState<'valid' | 'invalid' | null>(null);
  // Compliance State
  const [complianceForm, setComplianceForm] = useState({
    offenderName: '',
    offenseType: '',
    description: '',
    latitude: '21.9497',
    longitude: '89.1833',
    severity: 'Medium'
  });
  const activeTrips = [{
    name: 'Rahim Uddin',
    permitId: 'PER-2024-001',
    range: 'Chandpai Range',
    station: 'Karamjal Station',
    entryTime: '06:00 AM'
  }, {
    name: 'Karim Sheikh',
    permitId: 'PER-2024-002',
    range: 'Sarankhola Range',
    station: 'Sharankhola Station',
    entryTime: '05:30 AM'
  }, {
    name: 'Fatema Begum',
    permitId: 'PER-2024-003',
    range: 'Khulna Range',
    station: 'Nalian Station',
    entryTime: '07:15 AM'
  }];
  const recentCases = [{
    id: 'CASE-001',
    type: 'Illegal Entry',
    status: 'open',
    date: '2024-03-28'
  }, {
    id: 'CASE-002',
    type: 'Poaching',
    status: 'resolved',
    date: '2024-03-25'
  }];
  const handleScan = (type: 'qr' | 'rfid') => {
    setView('scan');
    setTimeout(() => {
      setScanResult(Math.random() > 0.3 ? 'valid' : 'invalid');
      setView('result');
    }, 2000);
  };
  const handleReportCase = () => {
    alert('Case reported successfully!');
    setView('compliance');
    setComplianceForm({
      offenderName: '',
      offenseType: '',
      description: '',
      latitude: '21.9497',
      longitude: '89.1833',
      severity: 'Medium'
    });
  };
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" data-id="element-1412">
      {/* Mobile Frame */}
      <div className="w-full max-w-sm bg-white rounded-[3rem] shadow-2xl overflow-hidden flex flex-col h-[800px] border-[8px] border-gray-900 relative" data-id="element-1413">
        {/* Notch */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-6 bg-gray-900 rounded-b-2xl z-20" data-id="element-1414"></div>

        {/* Status Bar */}
        <div className="bg-[#1B5E20] pt-8 pb-4 px-6 flex-shrink-0" data-id="element-1415">
          <div className="flex items-center justify-between text-white" data-id="element-1416">
            <div className="flex items-center gap-2" data-id="element-1417">
              <div className="font-bold text-lg tracking-tight" data-id="element-1418">
                Forest Field App
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-1419">
              <div className="flex items-center gap-1.5 bg-white/10 px-2 py-1 rounded-full" data-id="element-1420">
                <div className={`w-2 h-2 rounded-full ${isOnline ? 'bg-green-400 animate-pulse' : 'bg-red-400'}`} data-id="element-1421"></div>
                <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-1422">
                  {isOnline ? 'Online' : 'Offline'}
                </span>
              </div>
              <button onClick={() => setIsOnline(!isOnline)} className="p-1.5 hover:bg-white/20 rounded-full transition-colors" data-id="element-1423">
                <RefreshCwIcon size={16} data-id="element-1424" />
              </button>
            </div>
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-1 overflow-y-auto bg-gray-50/50" data-id="element-1425">
          {view === 'home' && <div className="p-6 space-y-6" data-id="element-1426">
              <div className="space-y-1" data-id="element-1427">
                <h2 className="text-2xl font-black text-gray-900" data-id="element-1428">
                  Field Verification
                </h2>
                <p className="text-sm text-gray-500" data-id="element-1429">
                  Select a scanning method to verify permits
                </p>
              </div>

              {/* Action Cards */}
              <div className="grid gap-4" data-id="element-1430">
                <button onClick={() => handleScan('qr')} className="group w-full bg-white border border-gray-100 rounded-[2rem] p-6 flex items-center gap-5 hover:border-green-200 hover:bg-green-50/30 transition-all shadow-sm active:scale-[0.98]" data-id="element-1431">
                  <div className="w-16 h-16 bg-green-600 text-white rounded-2xl flex items-center justify-center shadow-lg shadow-green-600/20 group-hover:scale-110 transition-transform" data-id="element-1432">
                    <CameraIcon size={32} data-id="element-1433" />
                  </div>
                  <div className="text-left" data-id="element-1434">
                    <div className="font-bold text-lg text-gray-900" data-id="element-1435">
                      Scan QR Code
                    </div>
                    <div className="text-xs text-gray-500 font-medium" data-id="element-1436">
                      Verify permit entry/exit
                    </div>
                  </div>
                </button>

                <button onClick={() => handleScan('rfid')} className="group w-full bg-white border border-gray-100 rounded-[2rem] p-6 flex items-center gap-5 hover:border-green-200 hover:bg-green-50/30 transition-all shadow-sm active:scale-[0.98]" data-id="element-1437">
                  <div className="w-16 h-16 bg-[#2E7D32] text-white rounded-2xl flex items-center justify-center shadow-lg shadow-green-700/20 group-hover:scale-110 transition-transform" data-id="element-1438">
                    <RadioIcon size={32} data-id="element-1439" />
                  </div>
                  <div className="text-left" data-id="element-1440">
                    <div className="font-bold text-lg text-gray-900" data-id="element-1441">
                      Scan RFID
                    </div>
                    <div className="text-xs text-gray-500 font-medium" data-id="element-1442">
                      Tap card to reader
                    </div>
                  </div>
                </button>

                <button onClick={() => setView('compliance')} className="group w-full bg-white border border-gray-100 rounded-[2rem] p-6 flex items-center gap-5 hover:border-amber-200 hover:bg-amber-50/30 transition-all shadow-sm active:scale-[0.98]" data-id="element-1443">
                  <div className="w-16 h-16 bg-amber-600 text-white rounded-2xl flex items-center justify-center shadow-lg shadow-amber-600/20 group-hover:scale-110 transition-transform" data-id="element-1444">
                    <ShieldAlertIcon size={32} data-id="element-1445" />
                  </div>
                  <div className="text-left" data-id="element-1446">
                    <div className="font-bold text-lg text-gray-900" data-id="element-1447">
                      Forest Compliance
                    </div>
                    <div className="text-xs text-gray-500 font-medium" data-id="element-1448">
                      Report offenses & cases
                    </div>
                  </div>
                </button>
              </div>

              {!isOnline && <div className="bg-amber-50 border border-amber-100 rounded-2xl p-4 flex items-start gap-3" data-id="element-1449">
                  <WifiOffIcon className="text-amber-600 flex-shrink-0 mt-0.5" size={20} data-id="element-1450" />
                  <div className="text-sm" data-id="element-1451">
                    <div className="font-bold text-amber-900" data-id="element-1452">
                      Working Offline
                    </div>
                    <div className="text-amber-700 text-xs mt-0.5" data-id="element-1453">
                      Data will sync when connected
                    </div>
                    <button className="mt-2 text-amber-900 text-[10px] font-black uppercase tracking-widest bg-amber-200/50 px-2 py-1 rounded-md" data-id="element-1454">
                      3 pending syncs
                    </button>
                  </div>
                </div>}
            </div>}

          {view === 'scan' && <div className="flex flex-col items-center justify-center h-full p-6" data-id="element-1455">
              <div className="w-full aspect-square max-w-[280px] border-2 border-green-600/30 rounded-[3rem] flex items-center justify-center mb-8 relative overflow-hidden bg-white shadow-2xl" data-id="element-1456">
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-green-600/10 to-transparent animate-scan-line" data-id="element-1457"></div>
                <div className="absolute inset-4 border-2 border-dashed border-green-600/20 rounded-[2rem]" data-id="element-1458"></div>
                <CameraIcon size={80} className="text-green-600/20" data-id="element-1459" />
              </div>
              <div className="text-center space-y-2" data-id="element-1460">
                <div className="font-black text-2xl text-gray-900 tracking-tight" data-id="element-1461">
                  Scanning...
                </div>
                <p className="text-sm text-gray-500 font-medium" data-id="element-1462">
                  Position QR code or tap RFID card
                </p>
              </div>
            </div>}

          {view === 'result' && scanResult && <div className="p-6 space-y-6 animate-in fade-in slide-in-from-bottom-8 duration-500" data-id="element-1463">
              {/* Status Header */}
              <div className={`rounded-[2.5rem] overflow-hidden shadow-2xl shadow-gray-200 border-b-4 ${scanResult === 'valid' ? 'border-green-600 bg-white' : 'border-red-600 bg-white'}`} data-id="element-1464">
                <div className={`px-6 py-6 flex flex-col items-center text-center gap-3 ${scanResult === 'valid' ? 'bg-green-600' : 'bg-red-600'}`} data-id="element-1465">
                  <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center text-white backdrop-blur-md" data-id="element-1466">
                    {scanResult === 'valid' ? <CheckCircleIcon size={32} data-id="element-1467" /> : <XCircleIcon size={32} data-id="element-1468" />}
                  </div>
                  <div className="space-y-1" data-id="element-1469">
                    <h3 className="font-black text-2xl text-white tracking-tight uppercase" data-id="element-1470">
                      {scanResult === 'valid' ? 'Permit Valid' : 'Access Denied'}
                    </h3>
                    <div className="bg-black/10 px-3 py-1 rounded-full text-[10px] font-bold text-white/80 uppercase tracking-widest" data-id="element-1471">
                      Verified at{' '}
                      {new Date().toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                    </div>
                  </div>
                </div>

                <div className="p-6 space-y-8" data-id="element-1472">
                  {scanResult === 'valid' ? <>
                      {/* Beneficiary Header */}
                      <div className="flex items-center gap-5" data-id="element-1473">
                        <div className="relative" data-id="element-1474">
                          <div className="w-20 h-20 bg-gray-100 rounded-[1.5rem] flex items-center justify-center text-4xl shadow-inner border-2 border-white overflow-hidden" data-id="element-1475">
                            👤
                          </div>
                          <div className="absolute -bottom-1 -right-1 w-8 h-8 bg-green-500 rounded-full border-4 border-white flex items-center justify-center text-white" data-id="element-1476">
                            <CheckCircleIcon size={14} data-id="element-1477" />
                          </div>
                        </div>
                        <div className="space-y-1" data-id="element-1478">
                          <h4 className="text-2xl font-black text-gray-900 leading-tight" data-id="element-1479">
                            Rahim Uddin
                          </h4>
                          <div className="flex flex-wrap gap-2" data-id="element-1480">
                            <span className="px-2 py-0.5 bg-green-100 text-green-700 text-[10px] font-bold rounded-md uppercase tracking-wider" data-id="element-1481">
                              Active
                            </span>
                            <span className="px-2 py-0.5 bg-gray-100 text-gray-500 text-[10px] font-bold rounded-md uppercase tracking-wider" data-id="element-1482">
                              PER-2024-001
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Info Grid */}
                      <div className="grid grid-cols-2 gap-3" data-id="element-1483">
                        <div className="bg-gray-50 rounded-2xl p-4 border border-gray-100 space-y-1" data-id="element-1484">
                          <div className="flex items-center gap-1.5 text-gray-400" data-id="element-1485">
                            <NavigationIcon size={12} data-id="element-1486" />
                            <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-1487">
                              Range
                            </span>
                          </div>
                          <div className="text-sm font-black text-gray-900" data-id="element-1488">
                            Chandpai
                          </div>
                        </div>
                        <div className="bg-gray-50 rounded-2xl p-4 border border-gray-100 space-y-1" data-id="element-1489">
                          <div className="flex items-center gap-1.5 text-gray-400" data-id="element-1490">
                            <MapPinIcon size={12} data-id="element-1491" />
                            <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-1492">
                              Station
                            </span>
                          </div>
                          <div className="text-sm font-black text-gray-900" data-id="element-1493">
                            Karamjal
                          </div>
                        </div>
                        <div className="bg-gray-50 rounded-2xl p-4 border border-gray-100 space-y-1" data-id="element-1494">
                          <div className="flex items-center gap-1.5 text-gray-400" data-id="element-1495">
                            <FileTextIcon size={12} data-id="element-1496" />
                            <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-1497">
                              Type
                            </span>
                          </div>
                          <div className="text-sm font-black text-gray-900" data-id="element-1498">
                            Fishing
                          </div>
                        </div>
                        <div className="bg-gray-50 rounded-2xl p-4 border border-gray-100 space-y-1" data-id="element-1499">
                          <div className="flex items-center gap-1.5 text-gray-400" data-id="element-1500">
                            <CalendarIcon size={12} data-id="element-1501" />
                            <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-1502">
                              Expiry
                            </span>
                          </div>
                          <div className="text-sm font-black text-green-600" data-id="element-1503">
                            2024-04-05
                          </div>
                        </div>
                      </div>

                      {/* Vessel Card */}
                      <div className="bg-blue-600 rounded-[2rem] p-5 text-white shadow-xl shadow-blue-600/20 relative overflow-hidden" data-id="element-1504">
                        <ShipIcon size={100} className="absolute -right-8 -bottom-8 text-white/10 rotate-12" data-id="element-1505" />
                        <div className="relative z-10 space-y-4" data-id="element-1506">
                          <div className="flex items-center gap-2" data-id="element-1507">
                            <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur-sm" data-id="element-1508">
                              <ShipIcon size={16} data-id="element-1509" />
                            </div>
                            <h5 className="font-black text-sm uppercase tracking-wider" data-id="element-1510">
                              Vessel Details
                            </h5>
                          </div>
                          <div className="grid grid-cols-2 gap-4" data-id="element-1511">
                            <div className="space-y-0.5" data-id="element-1512">
                              <div className="text-[10px] font-bold text-white/60 uppercase tracking-widest" data-id="element-1513">
                                Name
                              </div>
                              <div className="text-sm font-black" data-id="element-1514">
                                MV Sundarban-1
                              </div>
                            </div>
                            <div className="space-y-0.5" data-id="element-1515">
                              <div className="text-[10px] font-bold text-white/60 uppercase tracking-widest" data-id="element-1516">
                                BLC No
                              </div>
                              <div className="text-sm font-black" data-id="element-1517">
                                2024-8821
                              </div>
                            </div>
                            <div className="space-y-0.5" data-id="element-1518">
                              <div className="text-[10px] font-bold text-white/60 uppercase tracking-widest" data-id="element-1519">
                                Type
                              </div>
                              <div className="text-sm font-black" data-id="element-1520">Trawler</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Compliance Alert */}
                      <div className="bg-red-50 rounded-[2rem] p-5 border-2 border-red-100 space-y-4" data-id="element-1521">
                        <div className="flex items-center gap-3" data-id="element-1522">
                          <div className="w-12 h-12 bg-red-600 text-white rounded-2xl flex items-center justify-center shadow-lg shadow-red-600/20" data-id="element-1523">
                            <ShieldAlertIcon size={24} data-id="element-1524" />
                          </div>
                          <div className="space-y-0.5" data-id="element-1525">
                            <div className="text-[10px] font-black text-red-400 uppercase tracking-widest" data-id="element-1526">
                              Compliance Alert
                            </div>
                            <div className="text-sm font-black text-red-900" data-id="element-1527">
                              Poaching (CASE-2024-002)
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center justify-between bg-white rounded-xl p-3 border border-red-100" data-id="element-1528">
                          <div className="flex items-center gap-2" data-id="element-1529">
                            <StatusBadge status="banned" data-id="element-1530" />
                            <span className="text-xs font-black text-red-600 uppercase tracking-tight" data-id="element-1531">
                              Entry Denied
                            </span>
                          </div>
                          <AlertTriangleIcon size={16} className="text-red-600 animate-pulse" data-id="element-1532" />
                        </div>
                      </div>
                    </> : <div className="text-center py-12 space-y-6" data-id="element-1533">
                      <div className="relative inline-block" data-id="element-1534">
                        <div className="w-24 h-24 bg-red-50 rounded-[2rem] flex items-center justify-center mx-auto border-2 border-red-100" data-id="element-1535">
                          <AlertTriangleIcon size={48} className="text-red-600" data-id="element-1536" />
                        </div>
                        <div className="absolute -top-2 -right-2 w-10 h-10 bg-red-600 text-white rounded-full border-4 border-white flex items-center justify-center" data-id="element-1537">
                          <XCircleIcon size={20} data-id="element-1538" />
                        </div>
                      </div>
                      <div className="space-y-2 px-4" data-id="element-1539">
                        <h4 className="text-2xl font-black text-gray-900 tracking-tight uppercase" data-id="element-1540">
                          Permit Expired
                        </h4>
                        <p className="text-sm text-gray-500 font-medium leading-relaxed" data-id="element-1541">
                          This permit expired on{' '}
                          <span className="text-red-600 font-black underline decoration-2 underline-offset-4" data-id="element-1542">
                            2024-03-20
                          </span>
                          . Access to the forest area is strictly prohibited.
                        </p>
                      </div>
                      <div className="bg-gray-900 text-white rounded-2xl p-4 text-xs font-bold uppercase tracking-widest leading-relaxed mx-4" data-id="element-1543">
                        Action: Escort to station office immediately
                      </div>
                    </div>}
                </div>
              </div>

              <button onClick={() => {
            setView('home');
            setScanResult(null);
          }} className="w-full py-5 bg-gray-900 text-white rounded-[2rem] font-black text-lg shadow-2xl shadow-gray-900/20 hover:bg-black transition-all active:scale-[0.98] uppercase tracking-widest" data-id="element-1544">
                Finish Verification
              </button>
            </div>}

          {view === 'compliance' && <div className="p-6 space-y-6" data-id="element-1545">
              <div className="flex items-center justify-between" data-id="element-1546">
                <div className="space-y-1" data-id="element-1547">
                  <h2 className="text-2xl font-black text-gray-900 leading-tight" data-id="element-1548">
                    Compliance
                  </h2>
                  <p className="text-sm text-gray-500" data-id="element-1549">Manage field offenses</p>
                </div>
                <button onClick={() => setView('report-case')} className="bg-[#1B5E20] text-white w-14 h-14 rounded-2xl shadow-xl shadow-green-900/20 flex items-center justify-center active:scale-95 transition-transform" data-id="element-1550">
                  <PlusIcon size={28} data-id="element-1551" />
                </button>
              </div>

              <div className="space-y-4" data-id="element-1552">
                <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em]" data-id="element-1553">
                  Recent Cases
                </h3>
                <div className="grid gap-3" data-id="element-1554">
                  {recentCases.map(c => <div key={c.id} className="bg-white border border-gray-100 rounded-[1.5rem] p-5 shadow-sm hover:shadow-md transition-shadow" data-id="element-1555">
                      <div className="flex justify-between items-start mb-3" data-id="element-1556">
                        <div className="space-y-0.5" data-id="element-1557">
                          <div className="font-black text-gray-900" data-id="element-1558">{c.id}</div>
                          <div className="text-xs text-gray-500 font-bold" data-id="element-1559">
                            {c.type}
                          </div>
                        </div>
                        <StatusBadge status={c.status as any} data-id="element-1560" />
                      </div>
                      <div className="text-[10px] text-gray-400 font-bold flex items-center gap-1.5 uppercase tracking-wider" data-id="element-1561">
                        <CalendarIcon size={10} data-id="element-1562" />
                        Filed on {c.date}
                      </div>
                    </div>)}
                </div>
              </div>

              <div className="bg-amber-600 rounded-[2rem] p-6 text-white shadow-xl shadow-amber-600/20 relative overflow-hidden" data-id="element-1563">
                <ShieldAlertIcon size={100} className="absolute -right-8 -bottom-8 text-white/10 rotate-12" data-id="element-1564" />
                <div className="relative z-10 space-y-2" data-id="element-1565">
                  <div className="flex items-center gap-2 font-black text-sm uppercase tracking-widest" data-id="element-1566">
                    <AlertTriangleIcon size={18} data-id="element-1567" />
                    Field Protocol
                  </div>
                  <p className="text-xs text-white/80 font-medium leading-relaxed" data-id="element-1568">
                    Always ensure your safety before reporting an offense. Use
                    the "Report Case" button to capture evidence and location.
                  </p>
                </div>
              </div>
            </div>}

          {view === 'report-case' && <div className="p-6 space-y-8" data-id="element-1569">
              <div className="flex items-center gap-4" data-id="element-1570">
                <button onClick={() => setView('compliance')} className="w-12 h-12 bg-white border border-gray-100 rounded-2xl flex items-center justify-center text-gray-400 active:scale-95 transition-transform shadow-sm" data-id="element-1571">
                  <XCircleIcon size={24} data-id="element-1572" />
                </button>
                <h2 className="text-2xl font-black text-gray-900 tracking-tight" data-id="element-1573">
                  Report Offense
                </h2>
              </div>

              <div className="space-y-6" data-id="element-1574">
                <div className="space-y-2" data-id="element-1575">
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-1" data-id="element-1576">
                    Offender Name
                  </label>
                  <input type="text" placeholder="Enter name or 'Unknown'" className="w-full px-5 py-4 bg-white border border-gray-100 rounded-2xl focus:ring-4 focus:ring-green-600/5 focus:border-green-600 outline-none transition-all font-bold text-gray-900 placeholder:text-gray-300 shadow-sm" value={complianceForm.offenderName} onChange={e => setComplianceForm({
                ...complianceForm,
                offenderName: e.target.value
              })} data-id="element-1577" />
                </div>

                <div className="space-y-2" data-id="element-1578">
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-1" data-id="element-1579">
                    Offense Type
                  </label>
                  <select className="w-full px-5 py-4 bg-white border border-gray-100 rounded-2xl focus:ring-4 focus:ring-green-600/5 focus:border-green-600 outline-none transition-all font-bold text-gray-900 shadow-sm appearance-none" value={complianceForm.offenseType} onChange={e => setComplianceForm({
                ...complianceForm,
                offenseType: e.target.value
              })} data-id="element-1580">
                    <option value="" data-id="element-1581">Select Offense</option>
                    <option value="Illegal Entry" data-id="element-1582">Illegal Entry</option>
                    <option value="Poaching" data-id="element-1583">Poaching</option>
                    <option value="Overharvesting" data-id="element-1584">Overharvesting</option>
                    <option value="Unauthorized Vessel" data-id="element-1585">
                      Unauthorized Vessel
                    </option>
                  </select>
                </div>

                <div className="grid grid-cols-2 gap-4" data-id="element-1586">
                  <div className="space-y-2" data-id="element-1587">
                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-1" data-id="element-1588">
                      Latitude
                    </label>
                    <div className="relative" data-id="element-1589">
                      <input type="text" readOnly className="w-full pl-10 pr-4 py-4 bg-gray-100 border-transparent rounded-2xl font-bold text-gray-500 text-sm" value={complianceForm.latitude} data-id="element-1590" />
                      <MapPinIcon size={14} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1591" />
                    </div>
                  </div>
                  <div className="space-y-2" data-id="element-1592">
                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-1" data-id="element-1593">
                      Longitude
                    </label>
                    <div className="relative" data-id="element-1594">
                      <input type="text" readOnly className="w-full pl-10 pr-4 py-4 bg-gray-100 border-transparent rounded-2xl font-bold text-gray-500 text-sm" value={complianceForm.longitude} data-id="element-1595" />
                      <MapPinIcon size={14} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1596" />
                    </div>
                  </div>
                </div>

                <div className="space-y-2" data-id="element-1597">
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-1" data-id="element-1598">
                    Description
                  </label>
                  <textarea rows={4} placeholder="Describe the situation..." className="w-full px-5 py-4 bg-white border border-gray-100 rounded-2xl focus:ring-4 focus:ring-green-600/5 focus:border-green-600 outline-none transition-all font-bold text-gray-900 placeholder:text-gray-300 shadow-sm resize-none" value={complianceForm.description} onChange={e => setComplianceForm({
                ...complianceForm,
                description: e.target.value
              })} data-id="element-1599"></textarea>
                </div>

                <button onClick={handleReportCase} disabled={!complianceForm.offenseType} className="w-full py-5 bg-red-600 text-white rounded-[2rem] font-black text-lg shadow-xl shadow-red-600/20 hover:bg-red-700 transition-all active:scale-[0.98] uppercase tracking-widest disabled:opacity-50 disabled:shadow-none" data-id="element-1600">
                  Submit Field Report
                </button>
              </div>
            </div>}
        </div>

        {/* Bottom Navigation */}
        <div className="border-t border-gray-100 px-8 py-6 bg-white flex-shrink-0" data-id="element-1601">
          <div className="flex justify-around items-center" data-id="element-1602">
            <button onClick={() => setView('home')} className={`flex flex-col items-center gap-1.5 transition-all ${view === 'home' || view === 'scan' || view === 'result' ? 'text-green-600 scale-110' : 'text-gray-300 hover:text-gray-400'}`} data-id="element-1603">
              <div className={`p-2 rounded-xl ${view === 'home' || view === 'scan' || view === 'result' ? 'bg-green-50' : ''}`} data-id="element-1604">
                <CameraIcon size={24} strokeWidth={view === 'home' || view === 'scan' || view === 'result' ? 3 : 2} data-id="element-1605" />
              </div>
              <span className="text-[9px] font-black uppercase tracking-[0.15em]" data-id="element-1606">
                Scan
              </span>
            </button>
            <button onClick={() => setView('compliance')} className={`flex flex-col items-center gap-1.5 transition-all ${view === 'compliance' || view === 'report-case' ? 'text-amber-600 scale-110' : 'text-gray-300 hover:text-gray-400'}`} data-id="element-1607">
              <div className={`p-2 rounded-xl ${view === 'compliance' || view === 'report-case' ? 'bg-amber-50' : ''}`} data-id="element-1608">
                <ShieldAlertIcon size={24} strokeWidth={view === 'compliance' || view === 'report-case' ? 3 : 2} data-id="element-1609" />
              </div>
              <span className="text-[9px] font-black uppercase tracking-[0.15em]" data-id="element-1610">
                Cases
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>;
}